import * as React from 'react';
import style from '../import_tool.less';
import { StructureEditorDetail } from '../../../core/structure/StructureEditorDetail';
import { generateStructureKey } from '../../../core/structure/StructureKeyGen';
import { structureFromImport } from './helpers/StructureFromImport';
import { lazyInject } from '../../../services/inversify';
import { StructureService } from '../../../services/structure_service';

interface ImportStructureEditorProps extends React.ClassAttributes<any> {
    modul: string;
    entityNameSuggestion?: string;
    titleRow: number[];
    data: Array<any>;
    onDialogClose: () => void;
}
interface ImportStructureEditorState {
    entityName: string;
    entityKey: string;
    structureData: any;
    countInfo: Array<any>;
}
export class ImportStructureEditor extends React.Component<ImportStructureEditorProps, ImportStructureEditorState> {

    constructor(props: any) {
        super(props);
        this.state = {
            entityKey: undefined,
            entityName: this.props.entityNameSuggestion ? this.props.entityNameSuggestion : undefined,
            structureData: undefined,
            countInfo: []
        };
        this.sendEntityStructure = this.sendEntityStructure.bind(this);
        this.checkAndInitStructure = this.checkAndInitStructure.bind(this);
        this.onEntitySave = this.onEntitySave.bind(this);
        this.saveNewRef = this.saveNewRef.bind(this);
        this.setRefEntityStructure = this.setRefEntityStructure.bind(this);

        console.log('Basisdaten für Struktur', this.props.data);
    }
    @lazyInject(StructureService) private structureService: StructureService;
    render() {
        if (!this.state.structureData || !this.state.entityKey) {
            return this.getTitelForm();
        }
        return (<div>
            {this.getInfoBox()}
            <StructureEditorDetail
                entitySelected={this.state.entityKey}
                structureData={this.state.structureData}
                modul={this.props.modul}
                typeCountInfo = {this.state.countInfo}
                sendEntityStructure={this.sendEntityStructure}
                setRefEntityStructure={this.setRefEntityStructure}
            />
        </div>);
    }
    getInfoBox() {
        const hasRequired = this.hasKeyField();
        const reqStyle = hasRequired ? {} : { backgroundColor: '#FFFF00' };
        return (<div className={style.infobox_red}>
            <div style={{ fontSize: '12px' }}>
                Achtung, die nachfolgende Feld-Liste wurde automatisch aus der geladenen Tabelle ermittelt. <br />
                Folgendes bitte beachten:
                <ul>
                    <li>Bitte prüfen Sie, ob die Feldbezeichnungen korrekt sind.</li>
                    <li>Bitte entfernen Sie Felder, die nicht relevant sind.</li>
                    <li>Bitte definieren Sie Referenzen, falls erfoderlich.</li>
                    <li>Bitte passen Sie, falls erforderlich, die Feldtypen an.</li>
                    <li
                        style={reqStyle}
                    >Bitte wählen Sie mindestens 1 Feld als Schlüsselfeld aus.</li>
                </ul>
            </div>
            <input
                type='button'
                disabled={!hasRequired}
                value='Datenstruktur anlegen (und Datenbanktabelle erzeugen)'
                onClick={this.onEntitySave}
            />
        </div>);
    }
    hasKeyField() {
        const atts = this.state.structureData[this.state.entityKey].ATTS;
        console.log('ATTS', atts);
        const found = atts.find((att: any) => att.REQUIRED && att.REQUIRED.toString().toLowerCase() === 'key');
        return found !== undefined;
    }
    getTitelForm() {
        const structNames = this.structureService.getStructureNames(this.props.modul, false);
        const exists = structNames.find((sn: any) => sn.name === this.state.entityName ||
                                                     sn.key ===  'import_' + generateStructureKey(this.state.entityName)) ? true : false;
        // console.log(this.props.modul);
        // console.log(structNames);
        return (
            <div className={style.infobox}>
                <div>
                    Tite der neuen Datenstruktur: <br /> <br />
                    <input
                        value={this.state.entityName}
                        type='text'
                        onChange={(evt: any) => this.setState({ entityName: evt.target.value })}
                    />
                </div>
                <br />
                <div>
                    <input type='button'
                        value='Bezeichnung verwenden'
                        disabled = {exists}
                        onClick={() => this.checkAndInitStructure()}
                    />
                </div>
                {exists && <div className={style.infobox} style = {{fontSize: '12px', color: '#A00'}}>
                                Eine Datenstruktur mit dem  gleichen Titel <br /> oder der
                                gleichen (aus dem Titel abgeleiteten Kennung) <br /> existiert bereits!</div>}
            </div>);
    }

    checkAndInitStructure() {
        const name = this.state.entityName;
        const entityKey = 'import_' + generateStructureKey(name);
        const structureInfo = structureFromImport(entityKey, name, this.props.data, this.props.titleRow);
        const structureData = structureInfo.structData;
        const countInfo = structureInfo.countInfo;
        this.setState({ entityKey, structureData, countInfo });
    }

    sendEntityStructure(entityId: string, entityStructure: any): any {
        console.log(entityStructure);
        const structureData = this.state.structureData;
        structureData[entityId] = entityStructure;
        this.setState({ structureData });
    }

    setRefEntityStructure(refValues: any) {
        // console.log(refValues);
        const refStructure = this.structureService.getStructureRefEntity(this.state.entityKey, refValues.NAME, refValues.KEY);
        const refId = refStructure.SRC.id;

        const structureData = this.state.structureData;
        if (!structureData.hasOwnProperty(refId)) {
            structureData[refId] = refStructure;
            this.setState({ structureData });
            this.saveNewRef(refId, refStructure);
        }

        return refStructure;
    }

    saveNewRef(entityId: string, entityStructure: any) {
        this.structureService.saveEntityStructure(
            this.props.modul,
            entityId,
            'USER',
            entityStructure,
            (suc: boolean) => {
                if (!suc) {
                    alert('Speicherung vom Katalog fehlgeschlagen!');
                }
            }
        );
    }

    onEntitySave() {
        const confirmed = confirm('Diese Datenstruktur wirlklich erstellen? ' +
            'Danach ist die Bearbeitung nur noch über den Struktur-Editor möglich!');
        if (!confirmed) {
            return;
        }
        const key = this.state.entityKey;
        this.structureService.saveEntityStructure(
            this.props.modul,
            key,
            'USER',
            this.state.structureData[key],
            (suc: boolean) => {
                if (suc) {
                    this.structureService.reloadStructures();
                    this.props.onDialogClose();
                } else {
                    alert('Speicherung fehlgeschlagen!');
                }
            }
        );
    }

}
